// extracted by mini-css-extract-plugin
export default {"TabBar":"TabBar_TabBar__2zbb7","tab":"TabBar_tab__B5i8E","activeTab":"TabBar_activeTab__EfyXp","tabPanel":"TabBar_tabPanel__giTac","activeTabPanel":"TabBar_activeTabPanel__-SS9U"};